import { useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import CustomBreadcrumb from '../../../components/customBreadcrumb/CustomBreadcrumb';
import MainLoader from '../../../components/loading/MainLoader';
import StatusAlertModel from '../../../components/statusAlertModel/StatusAlertModel';
import TextInput from '../../../components/textInput/TextInput';
import Title from '../../../components/title/Title';
import { ISuccessState } from '../../../interfaces/successState';
import { redeemVoucher } from '../../../services/dashboard';
import styles from './RedeemData.module.scss';

export interface IFromInputs {
  serviceId: string;
  voucherId: string;
}

const RedeemData = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<IFromInputs>();
  const [isSuccess, setIsSuccess] = useState<ISuccessState | undefined>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const onSubmit = (data: IFromInputs) => {
    setIsLoading(true);
    redeemVoucher(data.serviceId, data.voucherId)
      .then((res) => {
        setIsLoading(false);
        setIsSuccess({
          isSuccess: true,
          message: res,
        });
        reset();
      })
      .catch((err) => {
        setIsLoading(false);
        setIsSuccess({
          isSuccess: false,
          message: err.message,
        });
      });
  };

  return (
    <div className='page-container'>
      <MainLoader show={isLoading} />
      <CustomBreadcrumb
        items={[
          { path: '/', title: 'Home' },
          { path: '', title: 'Redeem Data' },
        ]}
      />

      <Title>Redeem Data</Title>

      <Row className='page-sub-container-v2 justify-content-center mt-4'>
        <Col className='col-md-10'>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Row className='justify-content-center'>
              <Col className='col-md-8'>
                <TextInput
                  label='Broadband ID'
                  required
                  textAlign='center'
                  useFormRegister={{
                    ...register('serviceId', { required: true }),
                  }}
                  errors={[
                    {
                      isShow: errors.serviceId?.type === 'required',
                      message: 'Broadband ID required',
                    },
                  ]}
                />
              </Col>
            </Row>
            <Row className='justify-content-center mt-3'>
              <Col className='col-md-8'>
                <TextInput
                  label='Voucher ID'
                  required
                  textAlign='center'
                  useFormRegister={{
                    ...register('voucherId', { required: true }),
                  }}
                  errors={[
                    {
                      isShow: errors.voucherId?.type === 'required',
                      message: 'Voucher ID required',
                    },
                  ]}
                />
              </Col>
            </Row>
            <Row>
              <Col className={[styles.note, 'mt-3 text-center'].join(' ')}>
                <span className={styles.title}>Note: </span>
                <span className={styles.text}>
                  Enter the promo code on the voucher to avail ourself with the
                  offer
                </span>
              </Col>
            </Row>
            <Row className='mt-5 justify-content-center'>
              <Col className='col-md-6'>
                <Button type='submit' className='w-100' variant='success'>
                  Submit
                </Button>
              </Col>
            </Row>
          </form>
        </Col>
      </Row>
      <StatusAlertModel isSuccess={isSuccess} setIsSuccess={setIsSuccess} />
    </div>
  );
};

export default RedeemData;
